<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <router-link :to="{ name: 'top' ,
                    params: { brandPath: $route.params.brandPath}} ">TOPへ</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{menuNameUpper}}</p>
                    <p class="menu_center_tex_l">{{menuNameLower}}</p>
                </div>
            </div>
        </div>
        <CookingCheckMenu />
    </div>
</template>

<script>
    import CookingCheckMenu from '@/app/components/CookingCheckMenu.vue'

    export default {
        name: 'CookingCheckIndex',
        components: {
            CookingCheckMenu
        },
        computed: {
            menuNameUpper: function () {
                const button = this.$store.getters['buttons/topButton'](this.$route.params.menuId)
                return 'upperButtonName' in button ? button.upperButtonName : ''
            },
            menuNameLower: function () {
                const button = this.$store.getters['buttons/topButton'](this.$route.params.menuId)
                return 'lowerButtonName' in button ? button.lowerButtonName : ''
            }
        },
    }
</script>
